import { render, staticRenderFns } from "./ChartjsHorizontalBarChartComplianceFixed.vue?vue&type=template&id=4df2ba19&"
import script from "./ChartjsHorizontalBarChartComplianceFixed.vue?vue&type=script&lang=js&"
export * from "./ChartjsHorizontalBarChartComplianceFixed.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsHorizontalBarChartComplianceFixed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports